import { GetStaticProps, NextPage } from "next";
import { NextSeo } from "next-seo";
import React from "react";
import { createTitle } from "../components/app/DefaultSEO";
import { InfoPagesWrapper } from "../components/InfoPagesWrapper";
import { Fetcher } from "../Fetcher";

const PrivacyPolicyPage: NextPage<{ HTML: string }> = ({ HTML }) => {
  return (
    <>
      <NextSeo title={createTitle("Privacy Policy")} />
      <InfoPagesWrapper
        dangerouslySetInnerHTML={{
          __html: HTML,
        }}
      />
    </>
  );
};

export default PrivacyPolicyPage;

export const getStaticProps: GetStaticProps = async () => {
  const res = await Fetcher.getPrivacyPoliciesPage();

  const privacyPolicy = res.data.privacyPolicyPages[0];
  if (!privacyPolicy)
    return {
      notFound: true,
    };

  return {
    props: {
      HTML: privacyPolicy.content.html,
    },
  };
};
